var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (html, text) {if (text) {
pug_html = pug_html + "\u003Ch3\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E";
}
else
if (html) {
pug_html = pug_html + (null == (pug_interp = html) ? "" : pug_interp);
}}.call(this,"html" in locals_for_with?locals_for_with.html:typeof html!=="undefined"?html:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined));;return pug_html;};
module.exports = template;